import React from 'react';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import TenantUsersListTableRow from '../../components/tenantUsersListTableRow';
import ShowAssignEquipment from '../../components/modals/tenantUsers/showAssignEquipment';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import _ from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { gql } from '@apollo/client';
import constants from '../../../utils/constants';
import TenantUserDetails from '../../components/modals/projects/tenantUserDetails';
import jwt_decode from 'jwt-decode';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from '../../components/modals';
import ReactSlider from 'react-slider';

const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;

const getTenantUsersList = gql`
	query VendorTenantUsersList($filters: TenantUsersFiltersInput, $vendorId: String!) {
		vendorTenantUsersList(filters: $filters) {
			data {
				id
				firstName
				lastName
				displayName
				isShooter
				email
				isEmailVerified
				phoneNumber
				eventEqs
				individualEqs
				mcs
				accessibleTenants {
					tenant_id
					workspaceId
					role
				}
				accessibleBranches {
					_id
					branchId
				}
				isFreelancer
				isSuspended
				skillLevel {
					candidPhotography
					candidCinematography
					traditionalPhotography
					traditionalVideography
					leadership
				}
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;

const getOnlyTenantUsersList = gql`
	query VendorTenantUsersList($filters: TenantUsersFiltersInput) {
		vendorTenantUsersList(filters: $filters) {
			data {
				id
				firstName
				lastName
				displayName
				isShooter
				email
				isEmailVerified
				phoneNumber
				eventEqs
				individualEqs
				mcs
				accessibleTenants {
					tenant_id
					workspaceId
					role
				}
				accessibleBranches {
					_id
					branchId
				}
				isFreelancer
				isSuspended
				skillLevel {
					candidPhotography
					candidCinematography
					traditionalPhotography
					traditionalVideography
					leadership
				}
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
	}
`;
const edituser = gql`
	mutation UpdateTenantUser($userId: ID!, $userInput: UpdateTenantUserInput) {
		updateTenantUser(userId: $userId, userInput: $userInput) {
			id
		}
	}
`;
class VendorTenantUsers extends ProjectsGraphQlController {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			limit: 30,
			page: 1,
			searchQuery: '',
			sortBy: '',
			sortType: 0,
			currentViewPage: 1,
			isPageLoading: false,
			totalPages: 1,
			tenantUsersList: [],
			associatedTenants: [],
			columns: [
				{ title: 'Name', className: 'wedding-details-column' },
				{ title: 'Phone Number', className: 'wedding-details-column' },
				{ title: 'EQ', className: 'wedding-details-column' },

				{ title: 'MC', className: 'wedding-details-column' },
				{ title: 'Shooter', className: 'wedding-details-column' },
			],
			workspacesFilters: [],
			branchesListOption: [],
			workspaceActiveFilter: [],
			workspaceFilterCleared: false,
			branchIdsActiveFilter: [],
			showSearchDropDown: false,
			showShootEq: false,
			showIndividualEq: false,
			showMc: false,
			searchType: 'name',
			showMemberModal: false,
			userModalType: 'add',
			activeUserID: null,
			adminUserIDs: ['626d3751c5c41818a3994c97', '6128dd2f4253cefe5154c52b'],
			isShowCalender: false,
			isShowSkillSetModal: false,
			isBranchesListLoading: true,
			startDate: null,
			endDate: null,
			skillFilters: {},
			skillSetOptions: [
				{
					value: 'leadership',
					displayText: 'Leadership',
				},
				{
					value: 'candidPhotography',
					displayText: 'Candid Photo',
				},
				{
					value: 'traditionalPhotography',
					displayText: 'Traditional Photo',
				},
				{
					value: 'candidCinematography',
					displayText: 'Candid Video',
				},
				{
					value: 'traditionalVideography',
					displayText: 'Traditional Video',
				},
			],
		};
		this.calRef = React.createRef(null);
		this.searchDropDownRef = React.createRef();
		this.wrapper = React.createRef();
	}

	getActiveWorkspaceFilter = () => {
		if (_.size(this.state.workspaceActiveFilter) > 0) {
			return this.state.workspaceActiveFilter;
		}
		// If user explicitly cleared the workspace filter, return null to fetch all data
		if (this.state.workspaceFilterCleared) return null;
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			return vendorConfig.activeWorkspaces.map(w => w.workspaceId);
		}
		return null;
	};

	componentDidMount = async () => {
		// Pre-select active workspaces from constants (extract workspaceId for filter keys)
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			this.setState({ workspaceActiveFilter: vendorConfig.activeWorkspaces.map(w => w.workspaceId) });
		}

		let usertoken = localStorage.getItem('usertoken');
		let decoded = await jwt_decode(usertoken);
		this.setState({
			userName: decoded.userName,
			userId: decoded.user_id,
		});

		this.getTenantUserData();
		await this.getBranchList(getBranchList);
	};

	getTenantUserData = async () => {
		let json = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;
			let tempCount = 0;
			let searchType = null;
			let tempUrlSearch = _.cloneDeep(urlSearch);
			while (tempCount < _.size(tempUrlSearch)) {
				let subString = tempUrlSearch[tempCount].split('=');

				if (subString[0] && subString[0] === 'searchType') {
					searchType = subString[1];
				}
				tempCount++;
			}
			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (
					subString[0] &&
					subString[0] !== 'searchType' &&
					_.findIndex(this.state.skillSetOptions, {
						value: subString[0].split('-')[0],
					}) === -1
				) {
					json = {
						filters: {
							...json.filters,
							[`${
								subString[0] === 'search'
									? searchType
									: _.findIndex(this.state.skillSetOptions, {
											value: subString[0].split('-')[0],
									  }) !== -1
									? `${subString[0].split('-')[0]}.${subString[0].split('-')[1]}`
									: subString[0]
							}`]:
								subString[0] === 'page' || subString[0] === 'limit'
									? parseInt(subString[1])
									: subString[0] === 'workspaceIds'
									? subString[1].split(',')
									: subString[0] === 'holdingEventEq' ||
									  subString[0] === 'holdingEq' ||
									  subString[0] === 'holdingMc'
									? subString[1] === 'true'
									: subString[0] === 'search'
									? new URLSearchParams(urlSearch[count]).get('search')
									: _.findIndex(this.state.skillSetOptions, {
											value: subString[0].split('-')[0],
									  }) !== -1 ||
									  subString[0] === 'startDate' ||
									  subString[0] === 'endDate'
									? parseInt(subString[1])
									: subString[1],
						},
						vendorId: this.props.params.vendorID,
					};
				}
				if (
					_.findIndex(this.state.skillSetOptions, {
						value: subString[0].split('-')[0],
					}) !== -1
				) {
					let hasKey = _.has(json.filters, subString[0].split('-')[0]);
					let tempObj = hasKey ? json.filters[subString[0].split('-')[0]] : [];
					let tempObj2 = {
						[subString[0].split('-')[1]]: parseInt(subString[1]),
					};

					json = {
						...json,
						filters: {
							...json.filters,
							[subString[0].split('-')[0]]: {
								...tempObj,
								...tempObj2,
							},
						},
					};
				}
				if (subString[0] === 'workspaceIds') {
					this.setState({
						workspaceActiveFilter: subString[1].split(','),
					});
				} else if (
					_.findIndex(this.state.skillSetOptions, {
						value: subString[0].split('-')[0],
					}) !== -1
				) {
					this.setState((prevState) => {
						let hasKey = _.has(prevState.skillFilters, `${subString[0].split('-')[0]}`);
						let tempObj = hasKey
							? prevState.skillFilters[subString[0].split('-')[0]]
							: [];

						let tempObj2 = {
							[subString[0].split('-')[1]]: parseInt(subString[1]),
						};
						return {
							skillFilters: {
								...prevState.skillFilters,
								[subString[0].split('-')[0]]: {
									...tempObj,
									...tempObj2,
								},
							},
						};
					});
				} else if (subString[0] === 'branchIds') {
					this.setState({
						branchIdsActiveFilter: subString[1].split(','),
					});
				} else if (subString[0] === 'page' || subString[0] === 'limit') {
					this.setState({
						[subString[0]]: parseInt(subString[1]),
					});
				} else if (subString[0] === 'startDate' || subString[0] === 'endDate') {
					this.setState({
						[subString[0]]: moment(subString[1], 'YYYYMMDD')._d,
					});
				} else if (subString[0] === 'holdingEventEq') {
					this.setState({
						showShootEq: subString[1] === 'true',
					});
				} else if (subString[0] === 'holdingEq') {
					this.setState({
						showIndividualEq: subString[1] === 'true',
					});
				} else if (subString[0] === 'holdingMc') {
					this.setState({
						showMc: subString[1] === 'true',
					});
				} else if (subString[0] === 'search') {
					this.setState({
						searchQuery: new URLSearchParams(urlSearch[count]).get('search'),
						searchType,
					});
				}
				count++;
			}
		} else {
			json = {
				filters: {
					limit: this.state.limit,
					page: this.state.currentViewPage,
				},
				vendorId: this.props.params.vendorID,
			};
		}
		// Apply active workspaces filter on initial load if not set from URL
		const wsFilter = this.getActiveWorkspaceFilter();
		if (wsFilter && !json.filters?.workspaceIds) {
			json = {
				...json,
				filters: {
					...json.filters,
					workspaceIds: wsFilter,
				},
			};
		}
		this.getVendorTenantUsersList(getTenantUsersList, json);
	};

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					isPageLoading: true,
					currentViewPage: this.state.currentViewPage + 1,
				},
				async () => {
					await this.fetchMoreTenantUsers();
				},
			);
		}
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				isPageLoading: true,
				currentViewPage: e,
			},
			async () => {
				await this.fetchMoreTenantUsers();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					isPageLoading: true,
					currentViewPage: this.state.currentViewPage - 1,
				},
				async () => {
					await this.fetchMoreTenantUsers();
				},
			);
		}
	};

	searchString = (e) => {
		this.setState({
			searchQuery: e.target.value.replace('+', ''),
			currentViewPage: 1,
			isPageLoading: true,
		});

		if (this.timeout) clearTimeout(this.timeout);
		this.timeout = setTimeout(async () => {
			this.fetchMoreTenantUsers();
		}, 1000);
	};

	handleActiveFilter = async (e, type, key) => {
		let array;

		array = [...this.state[`${type}ActiveFilter`]];

		if (array.includes(key) == false) {
			array.push(key);
		} else {
			const index = array.indexOf(key);
			if (index > -1) {
				array.splice(index, 1); // 2nd parameter means remove one item only
			}
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				isPageLoading: true,
				currentViewPage: 1,
			},
			() => this.fetchMoreTenantUsers(),
		);
	};
	applyFilter = (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				tenantUsersList: [],
				isPageLoading: true,
				...(type === 'workspace' ? { workspaceFilterCleared: false } : {}),
			},
			() => {
				this.fetchMoreTenantUsers();
			},
		);
	};

	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: [],
				currentViewPage: 1,
				isPageLoading: true,
				...(type === 'workspace' ? { workspaceFilterCleared: true } : {}),
			},
			() => this.fetchMoreTenantUsers(),
		);
	};

	handleAvailableShooters = () => {
		this.setState(
			{
				currentViewPage: 1,
				isPageLoading: true,
				tenantUsersList: [],
			},
			() => this.fetchMoreTenantUsers(),
		);
	};

	fetchMoreTenantUsers = async () => {
		const wsFilter = this.getActiveWorkspaceFilter();
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;

		//Condition for workspace
		if (wsFilter)
			queryString = `${queryString}&workspaceIds=${wsFilter.toString()}`;

		//Condition for Shoot Equipment
		if (this.state.showShootEq === true)
			queryString = `${queryString}&holdingEventEq=${this.state.showShootEq.toString()}`;

		//Condition for Individual Equipment
		if (this.state.showIndividualEq === true)
			queryString = `${queryString}&holdingEq=${this.state.showIndividualEq.toString()}`;

		//Condition for Individual Equipment
		if (this.state.showMc === true)
			queryString = `${queryString}&holdingMc=${this.state.showMc.toString()}`;

		//Condition for Search String
		if (_.size(this.state.searchQuery.trim()) > 0)
			queryString = `${queryString}&search=${this.state.searchQuery.trim()}&searchType=${
				this.state.searchType
			}`;

		//Condition for Available Shooters
		if (this.state.startDate !== null && this.state.endDate !== null)
			queryString = `${queryString}&startDate=${moment(this.state.startDate).format(
				'YYYYMMDD',
			)}&endDate=${moment(this.state.endDate).format('YYYYMMDD')}`;
		//Condition for branchIds
		if (_.size(this.state.branchIdsActiveFilter) > 0)
			queryString = `${queryString}&branchIds=${this.state.branchIdsActiveFilter.toString()}`;

		//Condition for skills
		if (_.size(this.state.skillFilters) > 0) {
			_.forEach(this.state.skillFilters, (skill, key) => {
				queryString = `${queryString}&${key}-min=${skill.min}&${key}-max=${skill.max}`;
			});
		}
		this.props.navigate(`/${this.props.params.vendorID}/tenant-users${queryString}`);

		let json = {
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
			},
			//ownerId: this.state.ownerIdActiveFilter,
		};

		//have to write conditions for date range.

		//Condition for Workspace
		if (wsFilter)
			json = {
				filters: {
					...json.filters,
					workspaceIds: wsFilter,
				},
			};

		//Condition for holding shoot equipment
		if (this.state.showShootEq === true)
			json = {
				filters: {
					...json.filters,
					holdingEventEq: true,
				},
			};
		//Condition for holding Individual Equipment
		if (this.state.showIndividualEq === true)
			json = {
				filters: {
					...json.filters,
					holdingEq: true,
				},
			};
		//Condition for Memory Card
		if (this.state.showMc === true)
			json = {
				filters: {
					...json.filters,
					holdingMc: true,
				},
			};
		//Condition for branchIds
		if (_.size(this.state.branchIdsActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					branchIds: this.state.branchIdsActiveFilter,
				},
			};
		//Condition for Available Shooters
		if (this.state.startDate !== null && this.state.endDate != null)
			json = {
				filters: {
					...json.filters,
					startDate: parseInt(moment(this.state.startDate).format('YYYYMMDD')),
					endDate: parseInt(moment(this.state.endDate).format('YYYYMMDD')),
					isShooter: true,
				},
			};

		if (_.size(Object.keys(this.state.skillFilters)) > 0)
			json = {
				filters: {
					...json.filters,
					...this.state.skillFilters,
				},
			};

		//condition for search
		if (_.size(this.state.searchQuery.trim()) > 0) {
			json.filters[this.state.searchType] = this.state.searchQuery.trim();
		}

		await this.getVendorTenantUsersList(getOnlyTenantUsersList, json);
	};

	handleSecondFilterChange = (type) => {
		this.setState(
			{
				[`show${type}`]: !this.state[`show${type}`],
				isPageLoading: true,
				currentViewPage: 1,
			},
			() => this.fetchMoreTenantUsers(),
		);
	};
	toggleCreateMember = (e, userID = null) => {
		this.setState({
			showMemberModal: true,
			userModalType: userID == null ? 'add' : 'edit',
		});
		if (userID !== null) {
			this.setState({
				activeUserID: userID,
			});
		}
	};
	handleTenantIsShooter = async (e, type, id) => {
		let json;
		json = {
			userId: id,
			userInput: {
				isShooter: type,
			},
		};
		await this.addTenantMember(edituser, json);
	};

	handleSkillSetModal = () => {
		this.setState({
			isShowSkillSetModal: !this.state.isShowSkillSetModal,
		});
	};

	toggleSearchDropDown = () => {
		this.setState({
			showSearchDropDown: !this.state.showSearchDropDown,
		});
	};

	toggleSearchType = (e, type) => {
		this.setState(
			{
				searchType: type,
				showSearchDropDown: false,
			},
			() => {
				this.setState({
					currentViewPage: 1,
				});
				this.fetchMoreTenantUsers();
			},
		);
	};

	onChange = (dates) => {
		const [start, end] = dates;
		this.setState({
			startDate: start,
			endDate: end,
		});
	};

	setRangeFunction = (skill, value) => {
		let skillFilters = this.state.skillFilters;
		skillFilters[skill] = {
			min: value[0],
			max: value[1],
		};

		this.setState({
			skillFilters,
		});
	};

	handleSearchUserUsingSKill = () => {
		this.setState(
			{
				isShowSkillSetModal: false,
				tenantUsersList: [],
				isLoading: true,
			},
			() => this.fetchMoreTenantUsers(),
		);
	};

	setSkillCheckBox = (skill) => {
		let skillFilters = this.state.skillFilters;

		if (_.has(this.state.skillFilters, skill)) {
			skillFilters = _.omit(skillFilters, [skill]);
		} else {
			skillFilters[skill] = {
				min: 0,
				max: 10,
			};
		}

		this.setState({
			skillFilters,
		});
	};

	render() {
		return (
			<div className="layout-wrapper">
				{this.state.isLoading === true || this.state.isBranchesListLoading === true ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						<div className="searchContainer">
							<a className="title">Tenant Users</a>
							<div className="searchWrapper">
								<div className="search-inner-left">
									<span className="search-icon">
										<SearchIcon />
									</span>
									<input
										placeholder="Search user"
										name={this.state.searchType}
										value={this.state.searchQuery}
										onChange={(e) => this.searchString(e)}
									/>
								</div>
								<div className="search-inner-right">
									<span className="in-text">in</span>
									<span
										className="search-dropdown-btn"
										style={{ position: 'relative' }}
									>
										<a
											className="search-type"
											onClick={(e) => this.toggleSearchDropDown(e)}
											ref={this.wrapper}
										>
											{this.state.searchType === 'name'
												? 'Name'
												: this.state.searchType === 'phoneNumber'
												? 'Phone Number'
												: ''}
											<b
												className={
													this.state.showSearchDropDown ? 'invert' : ''
												}
											>
												<DownIcon />
											</b>
										</a>
										{this.state.showSearchDropDown ? (
											<div
												className="search-dropdown right-zero search-type"
												ref={this.searchDropDownRef}
											>
												<a
													className={`item ${
														this.state.searchType === 'name'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'name')
													}
												>
													Name
												</a>
												<a
													className={`item ${
														this.state.searchType === 'phoneNumber'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'phoneNumber')
													}
												>
													Phone Number
												</a>
											</div>
										) : (
											''
										)}
									</span>
								</div>
							</div>
							{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
								<div
									className="create-shoot-btn"
									onClick={(e) => this.toggleCreateMember(e)}
								>
									+ Add Member
								</div>
							) : (
								''
							)}
						</div>

						<div className="filters">
							<Filter
								type={'workspace'}
								label={'Workspaces'}
								filters={this.state.workspacesFilters}
								activeFilter={this.state.workspaceActiveFilter}
								handleActiveFilter={(e, status, key) =>
									this.handleActiveFilter(e, 'workspace', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'workspace')}
								isMultipleSelectable={true}
								version="v2"
								applyFilter={this.applyFilter}
							/>
							<Filter
								type={'branchIds'}
								label={'Branch Id'}
								filters={this.state.branchesListOption}
								activeFilter={this.state.branchIdsActiveFilter}
								handleActiveFilter={(e, type, key) =>
									this.handleActiveFilter(e, 'branchIds', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'branchIds')}
								isMultipleSelectable={true}
								version="v2"
								applyFilter={this.applyFilter}
							/>
							<div
								className={
									'alt-filter' +
									(this.state.showShootEq === true ? ' active' : '')
								}
								onClick={() => this.handleSecondFilterChange('ShootEq')}
							>
								<span className="af-text">Holding Shoot Equipment</span>
							</div>
							<div
								className={
									'alt-filter' +
									(this.state.showIndividualEq === true ? ' active' : '')
								}
								onClick={() => this.handleSecondFilterChange('IndividualEq')}
							>
								<span className="af-text">Holding Individual Equipment</span>
							</div>
							<div
								className={
									'alt-filter' + (this.state.showMc === true ? ' active' : '')
								}
								onClick={() => this.handleSecondFilterChange('Mc')}
							>
								<span className="af-text">Holding MC</span>
							</div>
							<div
								className={
									'alt-filter' +
									(_.size(this.state.skillFilters) > 0 ? ' active' : '')
								}
								onClick={() => this.handleSkillSetModal()}
							>
								<span className="af-text">Skill</span>
							</div>
							<div
								className={
									'alt-filter' +
									(this.state.startDate !== null && this.state.endDate !== null
										? ' active'
										: '')
								}
							>
								<div className="datePicker datePickerTU">
									<div className="dp-container">
										<DatePicker
											ref={this.calRef}
											selected={this.state.startDate}
											selectsRange
											startDate={this.state.startDate}
											endDate={this.state.endDate}
											shouldCloseOnSelect={false}
											placeholderText={'Available Shooters'}
											dayClassName={() => 'example-datepicker-day-class'}
											popperClassName="example-datepicker-class"
											onChange={this.onChange}
										>
											{' '}
											<div
												className=""
												style={{
													marginLeft: '80px',
												}}
											>
												<button
													style={{
														marginLeft: '10px',
														cursor: 'pointer',
														backgroundColor: '#F5F5F5',
														borderRadius: '4px',
														// color: 'white',
														border: 'none',
														padding: '6px 8px',
													}}
													onClick={() => {
														this.calRef.current.setOpen(false);
														this.setState({
															showCustomDate: false,
															currStatus: this.state.prevStatus,
														});
													}}
												>
													Cancel
												</button>
												<button
													style={{
														marginLeft: '10px',
														cursor: 'pointer',
														backgroundColor: '#2153CC',
														borderRadius: '4px',
														color: 'white',
														border: 'none',
														padding: '6px 8px',
													}}
													onClick={() => {
														this.calRef.current.setOpen(false);
														this.handleAvailableShooters();
													}}
												>
													Apply
												</button>
											</div>
										</DatePicker>
									</div>
								</div>
							</div>
						</div>

						<div className={'table tenant-users-table'}>
							<ProjectTable
								tableHeaderLeftPad={35}
								isLoading={this.state.isLoading}
								tableHeader={`SHOOTS`}
								columns={this.state.columns}
								activeSortType={this.state.sortType}
								activeSortBy={this.state.sortBy}
								//handleSort={this.handleProjectSort}
								isPageLoading={this.state.isPageLoading}
								limit={this.state.limit}
								totalPages={this.state.totalPages}
								currentViewPage={this.state.currentViewPage}
								lengthOfList={this.state.lengthOfList}
								onClickNextPage={this.onClickNextPage}
								onClickPreviousPage={this.onClickPreviousPage}
								dataList={this.state.tenantUsersList}
								goToPage={(e) => this.handleGoToPage(e)}
								module={'project'}
								searchQuery={''}
								mainFilter={''}
							>
								{_.map(this.state.tenantUsersList, (shoot, index) => {
									// let workspaceDetails = _.find(
									// 	this.state.workspaceList,
									// 	{
									// 		_id: equipment.tenantId,
									// 	}
									// );
									return (
										<TenantUsersListTableRow
											key={shoot.id}
											data={{
												...shoot,
												//workspaceDetails,
											}}
											handleTenantUserClick={(e) =>
												this.toggleCreateMember(e, shoot.id)
											}
											columns={this.state.columns}
											handleIsShooter={(e, type) =>
												this.handleTenantIsShooter(e, type, shoot.id)
											}
										/>
									);
								})}
							</ProjectTable>
						</div>
					</div>
				)}
				{this.state.showShowAssignEquipmentModal === true ? (
					<ShowAssignEquipment
						handleClose={() => this.showShowAssignEquipmentModal()}
						show={this.state.showShowAssignEquipmentModal}
						close={() => this.showShowAssignEquipmentModal()}
					/>
				) : null}
				{this.state.showMemberModal ? (
					<TenantUserDetails
						handleClose={() =>
							this.setState({
								showMemberModal: false,
								activeUserID: null,
								userModalType: 'add',
							})
						}
						show={this.state.showMemberModal}
						close={() =>
							this.setState(
								{
									showMemberModal: false,
									activeUserID: null,
									userModalType: 'add',
								},
								() => this.getTenantUserData(),
							)
						}
						vendorTenants={this.state.associatedTenants}
						activeUserID={this.state.activeUserID}
						userModalType={this.state.userModalType}
						tenantUserDetails={
							this.state.activeUserID == null
								? null
								: _.filter(this.state.tenantUsersList, {
										id: this.state.activeUserID,
								  })[0]
						}
						branchesListOption={this.state.branchesListOption}
					/>
				) : null}

				{this.state.isShowSkillSetModal ? (
					<Modal
						handleClose={() => this.handleSkillSetModal()}
						show={this.state.isShowSkillSetModal}
						modalType={'center'}
					>
						<div
							className="mc-record-center-modal"
							style={{ width: '30vw', height: '30vh' }}
						>
							<div className="mc-record-header">
								<span className="header-title">SEARCH BY SKILL</span>
							</div>
							<div
								className="mc-record-body"
								style={{
									padding: '20px 30px',
									flexDirection: 'column',
								}}
							>
								{_.map(this.state.skillSetOptions, (skillSet) => {
									return (
										<div className={'skill-set-container'}>
											<div className="checkBoxContainer">
												<label class="checkbox-container">
													<input
														type="checkbox"
														onChange={(e) =>
															this.setSkillCheckBox(skillSet.value)
														}
														checked={
															_.has(
																this.state.skillFilters,
																skillSet.value,
															)
																? true
																: false
														}
													/>
													<span class="checkmark"></span>
												</label>
												<span className="name">{skillSet.displayText}</span>
												{_.has(this.state.skillFilters, skillSet.value) ? (
													<span className="skillScoreContainer">
														<div className="skillScore">
															<p>
																{
																	this.state.skillFilters[
																		skillSet.value
																	]['min']
																}
															</p>
														</div>{' '}
														<span>-</span>
														<div className="skillScore">
															<p>
																{
																	this.state.skillFilters[
																		skillSet.value
																	]['max']
																}
															</p>
														</div>
													</span>
												) : (
													''
												)}
											</div>
											{_.has(this.state.skillFilters, skillSet.value) ? (
												<ReactSlider
													className="horizontal-slider"
													thumbClassName="example-thumb"
													trackClassName="example-track"
													min={0}
													max={10}
													defaultValue={
														_.has(
															this.state.skillFilters,
															skillSet.value,
														)
															? [
																	this.state.skillFilters[
																		skillSet.value
																	]['min'],
																	this.state.skillFilters[
																		skillSet.value
																	]['max'],
															  ]
															: [0, 10]
													}
													ariaLabel={['Lower thumb', 'Upper thumb']}
													ariaValuetext={(state) =>
														`Thumb value ${state.valueNow}`
													}
													renderThumb={(props, state) => (
														<div {...props}>{state.valueNow}</div>
													)}
													pearling
													minDistance={0.5}
													onChange={(value, index) =>
														this.setRangeFunction(skillSet.value, value)
													}
												/>
											) : (
												''
											)}
										</div>
									);
								})}
							</div>

							<div
								className="create-shoot-btn"
								style={{ margin: 'auto' }}
								onClick={(e) => this.handleSearchUserUsingSKill(e)}
							>
								Search User
							</div>
						</div>
					</Modal>
				) : (
					''
				)}
			</div>
		);
	}
}

export default withRouter(VendorTenantUsers);
